import EmptyPredictionsSubtext from '@porterin/booking-flow/src/order-review/view/components/EmptyPredictionsSubtext';
import EmptyPredictionsText from '@porterin/booking-flow/src/order-review/view/components/EmptyPredictionsText';
import {
  OrderReviewAssets,
  OrderReviewLabels,
} from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import Image from 'next/image';
import React from 'react';

const EmptyPredictionsCmp: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-[4rem]">
      <Image
        height={44}
        width={44}
        src={OrderReviewAssets.searchIcon.src}
        alt={OrderReviewAssets.searchIcon.alt}
        quality={70}
      />
      <EmptyPredictionsText
        text={OrderReviewLabels.emptyPredictionsText}
        id="empty-predictions-title"
      />
      <EmptyPredictionsSubtext
        text={OrderReviewLabels.emptyPredictionsSubtext}
        id="empty-predictions-subtitle"
      />
    </div>
  );
};

export default EmptyPredictionsCmp;
